import { SET_SITE_COLOR, SET_SEARCH_VALUE } from './actions';

export function siteColorReducer(siteColor = true, action) {
    switch (action.type) {
        case SET_SITE_COLOR:
            return action.siteColor;
        default:
            return siteColor;
    }
}

export function searchValueReducer(searchValue = '', action) {
    switch (action.type) {
        case SET_SEARCH_VALUE:
            return action.searchValue;
        default:
            return searchValue;
    }
}
